import React, { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const FAQFloatingButton = ({ isDarkMode }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to="/faq"
      className="fixed bottom-8 right-8 z-50 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Tooltip */}
      <div 
        className={`absolute right-full mr-3 top-1/2 -translate-y-1/2 px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-300 ${
          isDarkMode ? 'bg-[#1a2625] border border-[#284139]' : 'bg-[#284139] border border-[#284139]'
        } ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'}`}
      >
        <span className={`text-sm font-medium ${isDarkMode ? 'text-[#f5f5f5]' : 'text-[#E5D9B6]'}`}>Have questions?</span>
        <div className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-2 h-2 rotate-[-45deg] ${
          isDarkMode ? 'bg-[#1a2625] border-r border-b border-[#284139]' : 'bg-[#284139] border-r border-b border-[#284139]'
        }`} />
      </div>

      {/* Button */}
      <div className="relative">
        {/* Glow effect */}
        <div className={`absolute inset-0 rounded-full blur-xl transition-all duration-300 ${
          isDarkMode ? 'bg-[#E5D9B6]/30 group-hover:bg-[#E5D9B6]/50' : 'bg-[#284139]/30 group-hover:bg-[#284139]/50'
        }`} />
        
        {/* Button circle */}
        <div className={`relative w-14 h-14 rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-all duration-300 ${
          isDarkMode 
            ? 'bg-[#E5D9B6] shadow-[#E5D9B6]/30 group-hover:shadow-[#E5D9B6]/50'
            : 'bg-[#284139] shadow-[#284139]/30 group-hover:shadow-[#284139]/50'
        }`}>
          <HelpCircle className={`w-6 h-6 ${isDarkMode ? 'text-[#284139]' : 'text-[#E5D9B6]'}`} />
        </div>

        {/* Pulse ring */}
        <div className={`absolute inset-0 rounded-full border-2 animate-ping opacity-30 ${isDarkMode ? 'border-[#E5D9B6]' : 'border-[#284139]'}`} />
      </div>
    </Link>
  );
};

export default FAQFloatingButton;
